export default __webpack_public_path__ + "images/0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2.png";